.group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.toggle {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  min-block-size: var(--control-sm);
  padding-inline: var(--space-3);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
  font-size: var(--text-sm);
  white-space: nowrap;
  cursor: pointer;
}

.toggle:hover {
  background: var(--color-surface-hover);
}

/* On: the selection fill and a doubled accent border, so the state doesn't rest on color alone. */
.toggle[data-pressed] {
  padding-inline: calc(var(--space-3) - var(--border-width));
  border-width: calc(var(--border-width) * 2);
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
}

.toggle:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.toggle[data-disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}
